export interface ProvinceType {
    id: string;
    province: string;
    pinyin: string;
    city: CityType[];
}

export interface DistrictType {
    id: string;
    district: string;
    pinyin: string;
}

export interface CityType {
    id: string;
    city: string;
    district: DistrictType[];
    pinyin: string;
}

export interface FormatLetterItemType {
    letter: string;
    province: ProvinceType[];
}

export interface ProvinceFormFieldsType {
    home_state: string; // 省
    home_city: string; // 市
    home_district: string; // 区
}

export enum SelectTypeEnum {
    PROVINCE,
    CITY,
    DISTRICT
}
